// extracted by mini-css-extract-plugin
export var footer = "_r9-0";
export var inherit = "_r9-1";
export var input = "_r9-2";
export var modalContent = "_r9-3";
export var quillEditor = "_r9-4";
export var subtitle = "_r9-5";